/**
 * Export component file to be used on project
 */

import CartList from './CartList';
export default CartList;